import React from 'react';

import useScreenWidth from '@/hooks/useScreenSize';

import ContentCardSkeleton from './ContentCardSkeleton';

const ContentGridSkeleton = () => {
  const screenWidth = useScreenWidth();
  const skeletonItems = screenWidth > 1920 ? 10 : 8;
  return (
    <div className="sl-content-grid-skeleton">
      {[...Array(skeletonItems)].map((_, index) => (
        <ContentCardSkeleton key={index} />
      ))}
    </div>
  );
};

export default ContentGridSkeleton;
